<div *ngIf="showDev">
  <a routerLink="/logout">Logout</a>

  <h1>TYT Accounts System</h1>

  <app-notice></app-notice>

  <h2>Tooltip Button Test</h2>

  Here is a tooltip button:
  <tyt-tooltip-button>
    <button>Button</button>
    <div class="popout">
      This is the popout
    </div>
  </tyt-tooltip-button>

  <div style="text-align: right;">
    <tyt-tooltip-button>
      <button>Right Side</button>
      <div class="popout">
        This is the popout
      </div>
    </tyt-tooltip-button>
  </div>
  <div style="text-align: left;">
    <tyt-tooltip-button>
      <button>Left Side</button>
      <div class="popout">
        This is the popout
      </div>
    </tyt-tooltip-button>
  </div>

  <h2>Vertical Carousel Test</h2>

  <tyt-vertical-carousel>
    <tyt-vertical-carousel-item>Card 1</tyt-vertical-carousel-item>
    <tyt-vertical-carousel-item>Card 2</tyt-vertical-carousel-item>
    <tyt-vertical-carousel-item>Card 3</tyt-vertical-carousel-item>
  </tyt-vertical-carousel>

  <div class="alert alert-warning">
    <strong>Development</strong>
    <p>This page is only shown in development.
      In production, this route redirects to tytnetwork.com.
    </p>
  </div>

  <h2>Sign In via Token</h2>

  <p>Sign in with a token generated by TYT Platform. Use <code>rake dev:make_membership</code> to
  create a user account with a Stripe sandbox membership and acquire an auth token.</p>

  <form (submit)="signInViaToken()">
    <input name="token" [(ngModel)]="signInToken" type="text" placeholder="Token (eyJh...)" />
    <button>Sign In</button>
  </form>

  <h2>App Status</h2>
  <div>
    <label class="key">Config: </label>
    {{ appStatus ? 'Loaded' : 'Loading...'}}
  </div>
  <pre>{{appStatus | json}}</pre>

  <h2>Environment</h2>
  <pre>{{appConfigs | json}}</pre>

  <h1>Site-Wide Alerts</h1>
  <pre>{{alerts | json}}</pre>
  <a class="btn btn-primary" href="javascript:;" (click)="addAlert()">Add test alert</a>

  <h2>Server Transport Information</h2>
  <div>
    <label class="key">Request Info: </label>
    {{ request ? 'Present' : 'Missing'}}
  </div>
  <div>
    <label class="key">Capable of HTTP: </label>
    {{ response ? 'Yes' : 'No'}}
  </div>

  <hr/>

  <ul>
    <li><a routerLink="/login">Login</a></li>
    <li><a routerLink="/offers">Offers</a></li>
    <li><a routerLink="/signup">Registration</a></li>
    <li><a routerLink="/purchase">Purchase</a></li>
    <li><a routerLink="/gifts">Gifts Purchase</a></li>
    <li><a routerLink="/profile">Profile</a></li>
    <li><a routerLink="/account">Membership Account</a></li>
  </ul>

  <strong>Dialogs</strong><br/>
  <ul>
    <li><a href="javascript:;" (click)="showTestMessageDialog()">Message</a></li>
    <li><a href="javascript:;" (click)="showTestConfirmDialog()">Confirmation</a></li>
    <li><a href="javascript:;" (click)="showTestDialog()">Test</a></li>
  </ul>

  <br/>
  <strong>Notices</strong><br/>
  <ul>
    <li><a routerLink="/dev/test/notice">Do not post a notice (but change pages)</a></li>
    <li><a href="javascript:;" (click)="postNotice('good success is good!', 'success')">Post a success notice</a></li>
    <li><a href="javascript:;" (click)="postNotice('more information is better!', 'info')">Post an info notice</a></li>
    <li><a href="javascript:;" (click)="postNotice('error is bad!', 'danger')">Post an error notice</a></li>
    <li><a href="javascript:;" (click)="postNotice('warning is warned', 'warning')">Post a warning notice</a></li>
    <li><a href="javascript:;" (click)="dismissNotices()">Dismiss notices</a></li>
  </ul>

  <h2>Styles</h2>

  <div class="alert alert-success">
    Success!
  </div>
  <div class="alert alert-warning">
    Warning!
  </div>
  <div class="alert alert-danger">
    Danger!
  </div>

</div>

<h1>PayPal Test</h1>
<form ngNoForm action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
  <input type="hidden" name="cmd" value="_s-xclick">
  <input type="hidden" name="hosted_button_id" value="37KBNPFELBGXJ">
  <table>
  <tr><td><input type="hidden" name="on0" value="Enter your TYTNetwork Username">Enter your TYTNetwork Username</td></tr><tr><td><input style="color: black;" type="text" name="os0" maxlength="200"></td></tr>
  <tr><td><input type="hidden" name="on1" value="Enter your Membership Email">Enter your Membership Email</td></tr><tr><td><input style="color: black;" type="text" name="os1" maxlength="200"></td></tr>
  </table>
  <input type="submit" name="submit" value="Subscribe">
  <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
  </form>

